import React from 'react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-[#2A1D14] text-gray-400 py-10 px-4 text-center text-sm" data-id="element-103">
      <div className="max-w-4xl mx-auto" data-id="element-104">
        <p className="mb-4 font-heading font-bold text-caramel opacity-80 text-lg" data-id="element-105">
          FLANES SIN HORNO
        </p>
        <p className="mb-6" data-id="element-106">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
        <div className="flex flex-wrap justify-center gap-4 md:gap-8 mb-6" data-id="element-107">
          <a href="#" className="hover:text-white transition-colors" data-id="element-108">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-109">
            Políticas de Privacidad
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-110">
            Descargo de Responsabilidad
          </a>
        </div>
        <p data-id="element-111">
          &copy; {currentYear} Flanes Sin Horno. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}